// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
   apiKey: "AIzaSyDw4jjw7XrazbM8N2t3zDSjYvRH_C50RTw",
  authDomain: "accountabilitypartnerbyrpc.firebaseapp.com",
  projectId: "accountabilitypartnerbyrpc",
  storageBucket: "accountabilitypartnerbyrpc.appspot.com",
  messagingSenderId: "986042485955",
  appId: "1:986042485955:web:10c89ae577e1cde284a676",
  measurementId: "G-KCT234XSNN"
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
